import { render, staticRenderFns } from "./modalComponent.vue?vue&type=template&id=4d4e568f"
import script from "./modalComponent.vue?vue&type=script&lang=js"
export * from "./modalComponent.vue?vue&type=script&lang=js"
import style0 from "./modalComponent.vue?vue&type=style&index=0&id=4d4e568f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports